"use client";

import SidebarRecommendations from "@/app/ec/product/recommendations/sidebarRecommendations";
import { useState } from "react";

const AlgoliaSidebarRecommendationsSection = ({
  mpId: incomingMpId,
  categories,
  brandName,
}: AlgoliaSidebarRecommendationsProps) => {
  const [mpId] = useState(incomingMpId.toString());
  const lowestCategory = categories?.length > 0 ? categories[categories.length - 1].name : "";
  const secondLowestCategory = categories?.length > 1 ? categories[categories.length - 2].name : "";

  return (
    <>
      <SidebarRecommendations
        title="Related Best Sellers"
        model="related-products"
        objectIDs={[mpId]}
        maxRecommendations={5}
        modelParams={{
          fallbackParameters: {
            query: "",
            filters: `categoryPageId:"${secondLowestCategory}" AND availability:Y`,
          },
          queryParameters: {
            filters: `categoryPageId:"${lowestCategory}" AND availability:Y`,
          },
        }}
      />
      <SidebarRecommendations
        title={`More From ${brandName}`}
        model="related-products"
        objectIDs={[mpId]}
        maxRecommendations={5}
        modelParams={{
          queryParameters: {
            filters: `brand:"${brandName}" AND categoryPageId: "${lowestCategory}" AND availability:Y`,
          },
          fallbackParameters: {
            query: "",
            filters: `brand:"${brandName}" AND categoryPageId: "${lowestCategory}" AND availability:Y`,
          },
        }}
      />
      <SidebarRecommendations
        title="More From Other Brands"
        model="related-products"
        objectIDs={[mpId]}
        maxRecommendations={5}
        modelParams={{
          fallbackParameters: {
            filters: `NOT brand:"${brandName}" AND (categoryPageId:"${lowestCategory}" OR categoryPageId:"${secondLowestCategory}") AND availability:Y`,
          },
          queryParameters: {
            filters: `NOT brand:"${brandName}" AND categoryPageId:"${lowestCategory}" AND availability:Y`,
          },
        }}
      />
    </>
  );
};

interface AlgoliaSidebarRecommendationsProps {
  mpId: number;
  categories: CategoryTree[];
  brandName: string;
}

export default AlgoliaSidebarRecommendationsSection;
